<template>
    <ul role="list" class="divide-y divide-gray-200 rounded-md border border-gray-200" v-if="attachments.length">
        <li v-for="(attachment, index) in attachments">
            <div class="flex items-center justify-between py-3 pl-3 pr-4 text-sm">
                <div class="flex w-0 flex-1 items-start">
                    <IconPaperclip class="h-5 w-5 flex-shrink-0 text-gray-400" />
                    <span class="ml-2 w-0 flex-1 truncate"
                        >{{ attachment.name }}

                        <span
                            :class="
                                maxBytesSize && maxBytesSize < attachment.size
                                    ? 'text-red-400 font-bold'
                                    : 'text-gray-400'
                            "
                            >(
                            <BytesToUnit :bytes="attachment.size" />
                            )</span
                        >
                    </span>
                </div>
                <div class="ml-4 flex-shrink-0">
                    <button :title="$t('messages.remove')" @click="remove(index)">
                        <IconX class="w-6 h-6 text-gray-400 hover:text-red-400" />
                    </button>
                </div>
            </div>
            <AlertMessage class="mt-3 inline-block" v-if="maxBytesSize && maxBytesSize < attachment.size">
                <template v-slot:title>
                    {{ $t('messages.warning') }}
                </template>
                <template v-slot:body>
                    <div>
                        {{ $t('messages.file_too_big_warning') }}
                    </div>
                    <div>{{ $t('messages.max') }}: <BytesToUnit :bytes="maxBytesSize" /></div>
                </template>
            </AlertMessage>
        </li>
    </ul>
</template>

<script>
import { IconPaperclip, IconX } from '@tabler/icons-vue';

export default {
    name: 'AttachmentsUploadPreviews',
    components: {
        IconPaperclip,
        IconX,
    },
};
</script>
<script setup>
import BytesToUnit from '@/components/BytesToUnit.vue';
import AlertMessage from '@/components/AlertMessage.vue';

const emit = defineEmits(['remove']);
const remove = (index) => {
    emit('remove', index);
};

defineProps({
    attachments: {
        required: true,
        type: Array,
    },
    maxBytesSize: {
        type: Number,
        required: false,
        default: null,
    },
});
</script>
